var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FAF5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 11.2375C18.5438 11.0312 16.45 10.925 14.3625 10.925C13.125 10.925 11.8875 10.9875 10.65 11.1125L9.375 11.2375",
    stroke: "#F92E34",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 10.6062L12.95 9.7875C13.05 9.19375 13.125 8.75 14.1812 8.75H15.8188C16.875 8.75 16.9562 9.21875 17.05 9.79375L17.1875 10.6062",
    stroke: "#F92E34",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2812 13.2124L18.875 19.5062C18.8062 20.4874 18.75 21.2499 17.0062 21.2499H12.9937C11.25 21.2499 11.1938 20.4874 11.125 19.5062L10.7188 13.2124",
    stroke: "#F92E34",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.957 17.8125H16.0383",
    stroke: "#F92E34",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 15.3125H16.5625",
    stroke: "#F92E34",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.73caf6557da1fec4c748f749ae562456.svg";
export { ForwardRef as ReactComponent };